(function () {
  var badge = document.querySelector('[data-gc2-bottom-nav-cart-count]');
  if (!badge) return;

  function updateBadge(count) {
    if (count > 0) {
      badge.textContent = count > 99 ? '99+' : count;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateBadge(cart.item_count); })
    .catch(function () {});

  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadge(cart.item_count); })
      .catch(function () {});
  });
})();
